import React, { Component } from "react";

export class DayBar extends Component {
    alertCssClasses() {
        let cssClasses = "";
        if (this.props.isSnoozed) {
            cssClasses = '-snoozed';
        }
        cssClasses = `${cssClasses} -${this.props.alertLevel.toLowerCase()}`;
        return cssClasses;
    }

    renderCellClasses() {
        return `${this.baseCssClasses()} ${this.alertCssClasses()}`;
    }

    baseCssClasses() {
        throw new Error('This method must be overridden in the concrete component.');
    }

    renderTitle() {
        return null;
    }

    renderCellContent() {
        throw new Error('This method must be overridden in the concrete component.');
    }

    render() {
        return (
            <div title={this.renderTitle()} className={this.renderCellClasses()}>
                {this.renderCellContent()}
            </div>
        )
    }
}

